import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import {
  confirmToast,
  images,
  notifyDanger,
  notifySuccess,
} from "../../actions/customFn";
import axios from "../../api/axios";
import { useDispatch } from "react-redux";
import CertificateModal from "./CertificateModal";
import { asyncsendCertificate } from "../../actions/batchApi";

const ModuleStudent = ({ id }) => {
  const [batchStudents, setBatchStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  const [courseInfo, setCourseInfo] = useState({
    program: "",
    startDate: "",
    category: "",
  });

  const [isUpdate, setIsUpdate] = useState(false);

  const [certificateData, setCertificateData] = useState({});
  const { pathname } = useLocation();

const getCertificateData = () => {
  const url = `/batch/certificate-data/${id}`;
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
    },
  };

  return axios
    .get(url, config)
    .then((res) => {
      const { data } = res.data;
      setCertificateData(data);
    })
    .catch((err) => {
      notifyDanger(err.response?.data?.message || "Some Error Occured!");
    });
};
const getBatchStudents = () => {
  const splitPath = pathname.split("/")[2];
  const url = `batch/batch-students/${id}`;
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
    },
  };

  return axios
    .get(url, config)
    .then((res) => {
      const { data } = res.data;

      if (splitPath === "students") {
        setBatchStudents(data?.enroll_students || []);
      } else if (splitPath === "students-active") {
        setBatchStudents(
          data?.enroll_students.filter((d) => d.active === true)
        );
      } else if (splitPath === "students-deactive") {
        setBatchStudents(
          data?.enroll_students.filter((d) => d.active === false)
        );
      }

      setCourseInfo({
        program: data.courseInfo.title,
        startDate: data.batch_start,
        category: data.courseInfo.category,
      });
    })
    .catch((err) => {
      notifyDanger(err?.response?.data?.message || "some error occured");
    });
};

useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      await Promise.all([getBatchStudents(), getCertificateData()]);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [id, isUpdate, pathname]);

  return (
    <div className="module_student_container">
      <div className="module_student_navs">
        <NavLink to={`/batch/students/${id}`}>All</NavLink>
        <NavLink to={`/batch/students-active/${id}`}>Active</NavLink>
        <NavLink to={`/batch/students-deactive/${id}`}>Deactive</NavLink>
      </div>
      <div className="module_student_table scrollbar-template">
        { loading ? (
          <div className="loader-container">
            <p>Loading students...</p>
          </div>
        ) : batchStudents.length > 0 ? (
          <table className="table-template-style ">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Profile</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone No.</th>
                <th>Active/Deactive student</th>
                <th>Certificate</th>
              </tr>
            </thead>
            <tbody>
              {batchStudents.map((data, i) => {
                return (
                  <ModuleStudentItem
                    data={data}
                    index={i}
                    courseInfo={courseInfo}
                    certificateData={certificateData}
                    batchId={id}
                    setIsUpdate={setIsUpdate}
                  />
                );
              })}
            </tbody>
          </table>
        ) : (
          <h4 className="text-center text-black mt-4">No Students Found!</h4>
        )}
      </div>
    </div>
  );
};

export default ModuleStudent;

const ModuleStudentItem = ({
  data,
  index,
  courseInfo,
  certificateData,
  batchId,
  setIsUpdate,
}) => {
  const [modalShow, setShowModal] = useState(false);

  const [currentStudentDetails, setCurrentStudentDetails] = useState(null);
  // const [update, setUpdate] = useState(false);

  useEffect(() => {
    if (certificateData && certificateData?.student_details?.length > 0) {
      const isExist = certificateData?.student_details.find((val) => {
        return val.user === data._id;
      });
      setCurrentStudentDetails(isExist ? true : false);
    }
  }, [certificateData]);

  const handleButton = () => {
    const formData = {
      id: data._id,
      active: !data.active,
    };
    const url = `batch/active-students`;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
      },
    };
    axios
      .put(url, formData, config)
      .then((res) => {
        const { message } = res.data;
        notifySuccess(message);
        setIsUpdate((p) => !p);
      })
      .catch((err) => {
        notifyDanger(err.response.message || "Some error Occured");
      });
  };

  return (
    <tr key={index}>
      <td>{index + 1}</td>
      <td>
        <img alt="" src={data.image} />
      </td>
      <td>{data.username}</td>
      <td>{data.email}</td>
      <td>{data.phone_no}</td>
      <td>
        <div className="module_student_active_deactive">
          <button
            onClick={() => {
              confirmToast("Are you want to deactive this student ?", () => {
                handleButton(); // Add parentheses to call the function
              });
            }}
            className={`${data.active === false && "deactive"}`}
          >
            Deactive
          </button>
          <button
            onClick={() => {
              confirmToast("Are you want to active this student ?", () => {
                handleButton(); // Add parentheses to call the function
              });
            }}
            className={`${data.active === true && "active"}`}
          >
            Active
          </button>
        </div>
      </td>
      <td>
        <button
          disabled={currentStudentDetails}
          className={`${
            currentStudentDetails ? "disabled_certificatebtn" : ""
          }`}
          onClick={() => setShowModal(true)}
          style={{fontSize:15 , color: "white"}}
        >
          Send Certificate
        </button>
      </td>

      {modalShow && (
        <CertificateModal
          modalShow={modalShow}
          setShowModal={setShowModal}
          data={data}
          courseInfo={courseInfo}
          certificateData={certificateData}
          batchId={batchId}
          setIsUpdate={setIsUpdate}
        />
      )}
    </tr>
  );
};
